import styled from 'styled-components'

const SingleInvestmentProjectStyle = styled.div.attrs({ className: 'single-investment-project' })`
	.single-invest {
		.top-container {
			display: flex;
			flex-direction: column;

			.back-to {
				display: flex;
				align-items: center;
				margin-bottom: var(--sp2x);
				transform: translateY(30vh);
				i {
					margin-right: var(--sp1-5x);
				}
			}

			.top {
				display: flex;
				flex-wrap: wrap;
    			width: 100%;
				>div{
					flex: 0 0 50%;
					max-width: 50%;
				}
			}
		}

		.catalog-view {
			.top {
				.comp-title {
					margin-bottom: 0;
				}
			}
		}
	}


	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) =>
		props.theme.mediaQuery.DesktopSizeS}) {
		.single-invest {
			margin-top: var(--sp4x);
			
		}
	}

	@media screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) {
		.single-invest {
			.top-container {
				.back-to {
					margin-bottom: var(--sp1-5x);
				}

				.top {
					flex-direction: column;
					>div{
						flex: 0 0 100%;
						max-width: 100%;
					}
				}
			}
		}
	}
`
export default SingleInvestmentProjectStyle
